import React, { useEffect, useState } from 'react';
// import { Row, Col, Input, Button } from 'reactstrap';
import {
  TYPE_INPUT,
  TYPE_CHECKBOX,
  TYPE_DATETIME,
  TYPE_DROPDOWN,
  DropdownIfc,
  TYPE_DATE,
  TYPE_BUTTON,
  TYPES,
  TYPE_CHECKBOX_LIST,
  TYPE_DATE_HASTA,
  TYPE_CHECKBOXCUSTOM,
  TYPE_INPUT_TEXT,
  TYPE_DATE_PROJECT,
  TYPE_DATE_YEAR_MONTH,
} from '../../../common/list-utils';
// import Datetime from 'react-datetime';
import { DateTime } from 'luxon';
import { ListColumnFilter } from '../list-entities/ListColumnFilter';
import {
  DatePicker,
  DefaultButton,
  Dropdown,
  IDropdownOption,
  ITextFieldStyles,
  IDropdownStyles,
  TextField,
  Toggle,
  CommandBarButton,
  Text,
  IIconProps,
  IStackStyles,
  IDatePickerStyles,
  ComboBox,
  IComboBox,
  IComboBoxOption,
} from '@fluentui/react';
import './DetailsListView.css';
import moment from 'moment';

import 'moment/locale/es';
import { DateCustom } from '../../../lib/DateCustom';
import OrganizationChartSystem from '../../../system/organization_chart/OrganizationChartSystem';
import { OrganizationChartDropdown } from '../OrganizationChartDropdown';
import { OrganizationChartNode } from '../../../system/organization_chart/OrganizationChartNode';
import i18next, { t } from 'i18next';
import { getLocalizedStrings } from '../../../lib/LocalizedStringsForDatePicker';
import ComboBoxSearch from '../ComboBoxSearch';
import CheckboxFilterComponent, { Option } from '../../../lib/CheckboxFilterComponent';
import CustomDatePicker from '../../../lib/CustomDatePicker';
import useIsMobile from '../../../common/custom-hooks/useIsMobile';
import { DetailListStatus } from './DetailListStatus';

export interface FiltersConfigList {
  type: string;
  name: string;
  operator: string;
  placeholder?: string;
  grow?: number;
  contextForDropdown?: IDropdownOption<any>[];
  checkBoxValue?: string;
  labelForCheckBox?: string;
  customFilter?: any;
}

interface FilterWrapperProps {
  filtersConfigList: ListColumnFilter[];
  onChangeAnyFilter: (
      filters: { [index: string]: string },
      shouldUpdate: boolean,
      cleanFilters?: boolean,
      nameValue?: {[index: string]: string}
  ) => void;
  shouldUpdate: boolean;
  initFilters: any;
  filters: { [index: string]: string };
}

const FilterWrapperForList = (props: FilterWrapperProps) => {
  const [showAll, setShowAll] = useState<boolean>(false);
  const { isMobile } = useIsMobile();


  useEffect(() => {}, [props.filtersConfigList]);

  const onChangeToggle = (e: any, checked?: boolean) => {
    let val = '1';

    props.filtersConfigList.forEach((fc) => {
      if (fc.name === e.target.id && fc.checkBoxValue) {
        val = fc.checkBoxValue;
      }
    });
    let _filters = { ...props.filters };
    _filters[e.target.id] = _filters[e.target.id] === val ? '' : val;
    props.onChangeAnyFilter(_filters, !props.shouldUpdate);
  };

  const onChangeToggleButton = (e: any, name: string) => {
    let val = '1';
    props.filtersConfigList.forEach((fc: any) => {
      if (fc.name === name && fc.checkBoxValue) {
        val = fc.checkBoxValue;
      }
    });
    let _filters = { ...props.filters };

    _filters[name] = _filters[name] === val ? '' : val;
    props.onChangeAnyFilter(_filters, !props.shouldUpdate);
  };

  const onChangeFilter = (e: any) => {
    let _filters = { ...props.filters };

    if (e.target.name === 'col_id_sap') {
        _filters[e.target.name] = e.target.value;
    } else if (e.target.type === 'checkbox') {
        _filters[e.target.name] = _filters[e.target.name] === '1' ? '' : '1';
    } else {
        _filters[e.target.name] = e.target.value;
    }

    // Llamada al método onChangeAnyFilter para manejar el filtrado y la actualización del estado
    props.onChangeAnyFilter(_filters, !props.shouldUpdate);
};

  const _onChangeSelectFilter = (option: any, name: string) => {
    let _filters = { ...props.filters };

    _filters[name] = option.key;
    props.onChangeAnyFilter(_filters, !props.shouldUpdate);
  };

  const _onChangeSelectFiltersss = (option: any, name: string) => {
    let _filters = { ...props.filters };
    let nameValue = {[name]:option.text}
      _filters[name] = option.key;
    props.onChangeAnyFilter(_filters, !props.shouldUpdate,undefined,nameValue);
  };

  const _onChangeSelectFilterForOrganization = (key: string, name: string) => {
    let _filters = { ...props.filters };

    _filters[name] = key;
    props.onChangeAnyFilter(_filters, !props.shouldUpdate);
  };

  const onClearFilters = (e: any) => {
    let _filters = { ...props.filters };

    for (let prop in _filters) {
      let config = props.filtersConfigList.find((filterConfig) => filterConfig.name === prop);
      let defaultVal: any = config?.defaultValue;
      if (config?.defaultValue instanceof Date) {
        const d = DateTime.fromJSDate(config?.defaultValue);
        defaultVal = d.toUTC().toISO();
      }

      if (config?.defaultValue) _filters[prop] = defaultVal;
      else _filters[prop] = '';
    }
    props.onChangeAnyFilter(_filters, !props.shouldUpdate, true);
  };
  
/*   // Limpíar filtros, si tienen un valor por defecto se asigna ese valor, sino se asigna vacío
  const onClearFilters = () => {
    let _filters: any = {};

    props.filtersConfigList.forEach((filterConfig) => {
      _filters[filterConfig.name] = '';
    });

    props.onChangeAnyFilter(_filters, !props.shouldUpdate, true);
  };
 */
  const handleDateChangeWrapper = (e: any, name: string, isMonthSelector: boolean) => {
    let _filters = { ...props.filters };

    if (isMonthSelector) {
      e.setDate(1);
    }
    const d = DateTime.fromJSDate(e);
    //@ts-ignore
    _filters[name] = d.toUTC().toISO();
    props.onChangeAnyFilter(_filters, !props.shouldUpdate);
    let _d = new Date(_filters[name]);
    return _d;
  };


  const handleDateChangeWrapperMonth = (e: any, name: string, isMonthSelector: boolean) => {
    let _filters = { ...props.filters };

    if (isMonthSelector) {
      e.setDate(1);
    }
    const d = DateTime.fromJSDate(e);
    //@ts-ignore
    _filters[name] = d.toUTC().toISO();

    const formattedDate = `${e.getFullYear()}-${(e.getMonth() + 1).toString().padStart(2, '0')}`;

    _filters[name] = formattedDate;
    props.onChangeAnyFilter(_filters, !props.shouldUpdate);
    let _d = new Date(_filters[name]);
    return _d;
  };
  const getOptionByValue = (opt: any, context: any) => {
    let ret: string = '';
    if (opt) {
      let itemSelected = context.find((e: any) => e.key === opt);
      ret = itemSelected ? itemSelected.key : '';
    }
    return ret;
  };

  const getOptionByValuess = (opt: any, context: any) => {
    let ret: string = '';
    if (opt) {
      let itemSelected = context.find((e: any) => e.text === opt);
      ret = itemSelected ? itemSelected.key : '';
    }
    return ret;
  };

  const getOptionByValueForOrganization = (opt: any, context: OrganizationChartNode[] | undefined) => {
    let ret: string = '';
    if (opt) {
      if (context) {
        let itemSelected = context.find((e) => e.getId() === opt);
        ret = itemSelected ? itemSelected.getId() : '';
      }
    }
    return ret;
  };

  // Estilos sueltos
  const stackStyles: Partial<IStackStyles> = { root: { height: 32, fontSize: 12 } };
  const FilterIcon: IIconProps = { iconName: 'Filter' };
  const FilterClearIcon: IIconProps = { iconName: 'ClearFilter' };
  const dropdownStyles: Partial<IDropdownStyles> = {
    // dropdown: { minWidth: 150, maxWidth: 150 },
    callout: { minWidth: 300, maxWidth: 300 },
    title: {
      border: '1px solid #aaa',
    },
  };

  const CalendarStyles: Partial<IDatePickerStyles> = {
    textField: {
      fieldGroup: {
        border: '1px solid #aaa',
      }
    },
    root: {
      selectors: {
        label: {
          padding:0
        },
      },
    },
  };


  const controlStyles = {
    root: {
      maxWidth: '300px',
    },
    label: {
      color: '#aaa',
    },
    fieldGroup: {
      border: '1px solid #aaa',
    },
  };

  const textFieldStyles: Partial<ITextFieldStyles> = {
    field: {
      '::placeholder': {
        color: '#aaa',
      },
    },
    subComponentStyles: {
      label: {
        root: {
          padding: '1.5px 0px',
        },
      },
    },
  };

  const handleApply = (selectedOptions: Option[],name:string) => {
    let _filters = { ...props.filters };
    _filters[name] =  selectedOptions.map(item => item.text).join(' | ');
    props.onChangeAnyFilter(_filters, !props.shouldUpdate);
  }
  const textFieldStylesProject: Partial<ITextFieldStyles> = {
    field: {
      '::placeholder': {
        color: '#aaa',
      },width:'155px'
    },
    subComponentStyles: {
      label: {
        root: {
          padding: '1.5px 0px',
        },
      },
    },
  };

  return (
    <div>
      <div className="ms-Grid" dir="ltr">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, padding: '0 0 8px 0'}}>
          <div className="ms-md6 ms-hiddenXlUp">
            <Text block variant="medium">
              {t('Filtros')}
            </Text>
          </div>
          <div className="ms-Grid-col ms-md6 ms-xl12 ms-xxl12" style={{ display: 'flex', justifyContent: isMobile ? 'flex-end' : 'space-between', gap: '8px', padding: 0 }}>
            <CommandBarButton onClick={onClearFilters} className="float-right-media bg-transparent" allowDisabledFocus styles={stackStyles} iconProps={FilterClearIcon} text={t('Limpiar')} />

            {!showAll && <CommandBarButton className="float-right bg-transparent" onClick={() => setShowAll(true)} styles={stackStyles} iconProps={FilterIcon} text={t('Más')} />}
            {showAll && <CommandBarButton onClick={() => setShowAll(false)} className="float-right bg-transparent ms-sm-6" styles={stackStyles} iconProps={FilterClearIcon} text={t('Menos')} />}
          </div>
        </div>

        {/* FILTRAR Y MOSTAR EN UN DIV TODO LOS ITEMS DE TIPO TYPE_CHECKBOX*/}
        <div className="filtros-tipo-checkbox">
          {props.filtersConfigList
            ? props.filtersConfigList
                .filter((f) => f.type === TYPE_CHECKBOX || f.type === TYPE_CHECKBOX_LIST)
                .map((filterConfig, index) => {
                  if (!showAll && !filterConfig.quick) {
                    return null;
                  }
                  if (filterConfig.hidden) return null;
                  return (
                    <div className="checkbox c-checkbox" key={index}>
                      <label className="mb-1">
                        <Toggle label={filterConfig.labelForCheckbox} id={String(filterConfig.name)} checked={Boolean(props.filters[filterConfig.name])} styles={controlStyles} onClick={onChangeToggle} className={'filter-textfield-list'} disabled={filterConfig.disabled} />
                      </label>
                    </div>
                  );
                })
            : null}
        </div>

        {/* FILTRAR Y MOSTAR EN UN DIV TODO LOS ITEMS QUE NO SON DEL TIPO TYPE_CHECKBOX*/}
        <div className="ms-Grid-row" dir="ltr">
          {/* <div className="ms-Grid-col mt-more-filters"></div> */}
          {props.filtersConfigList
            ? props.filtersConfigList
                .filter((f) => f.type !== TYPE_CHECKBOX && f.type !== TYPE_CHECKBOX_LIST)
                .map((filterConfig, index) => {
                  if (!showAll && !filterConfig.quick) {
                    return null;
                  }
                  return (
                    <div className="ms-Grid-col ms-xl12 ms-sm6 ms-md-12" key={index}>
                        {!filterConfig.hidden && filterConfig.type === TYPE_INPUT ? <TextField label={filterConfig.placeholder} autoComplete={'off'} onChange={onChangeFilter} name={filterConfig.name} value={props.filters[filterConfig.name] ? props.filters[filterConfig.name] : ''} styles={textFieldStyles} className="filter-textfield-list" disabled={filterConfig.disabled} placeholder={filterConfig.example} /> : null}

                        {!filterConfig.hidden && filterConfig.type === TYPE_INPUT_TEXT ? <TextField label={filterConfig.placeholder} autoComplete={'off'} onChange={onChangeFilter} name={filterConfig.name} value={props.filters[filterConfig.name] ? props.filters[filterConfig.name] : ''} styles={textFieldStylesProject} className="filter-textfield-list" disabled={filterConfig.disabled} placeholder={filterConfig.example} /> : null}

                        {!filterConfig.hidden && filterConfig.type === TYPE_CHECKBOXCUSTOM && filterConfig.CheckboxCustom && (
                          <CheckboxFilterComponent
                            title={filterConfig.placeholder || ''}
                            titleStyle={{ label: { color: '#aaa', fontSize: '12px', fontFamily: 'Segoe UI', fontWeight: 600 } }}
                            initialOptions={filterConfig.CheckboxCustom}
                            onApply={(d) => handleApply(d, filterConfig.name)}
                            dropdownStyle={{
                              boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                              borderRadius: '5px',
                            }}
                            selectedKeys={props.filters[filterConfig.name] ? props.filters[filterConfig.name].split(' | ') : []}
                          />
                        )}
                        {!filterConfig.hidden && filterConfig.type === TYPE_DROPDOWN && filterConfig.contextForDropdown && (
                          <Dropdown
                            className="filter-textfield-list"
                            label={filterConfig.placeholder}
                            options={filterConfig.contextForDropdown}
                            selectedKey={getOptionByValue(props.filters[filterConfig.name], filterConfig.contextForDropdown)}
                            onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption<any> | undefined, index?: number | undefined) => {
                              _onChangeSelectFilter(option, filterConfig.name);
                            }}
                            disabled={filterConfig.disabled}
                            styles={dropdownStyles}
                          />
                        )}
                        {!filterConfig.hidden && filterConfig.type === TYPES.COMBOBOX && filterConfig.contextForOrganizationChartDropdown && (
                          <OrganizationChartDropdown
                            className="filter-textfield-list"
                            label={filterConfig.placeholder}
                            options={filterConfig.contextForOrganizationChartDropdown ? filterConfig.contextForOrganizationChartDropdown : []}
                            selectedKey={getOptionByValueForOrganization(props.filters[filterConfig.name], filterConfig.contextForOrganizationChartDropdown)}
                            onChange={(node: OrganizationChartNode) => {
                              _onChangeSelectFilterForOrganization(node.getId(), filterConfig.name);
                            }}
                          />
                        )}
                        {!filterConfig.hidden && filterConfig.type === TYPES.COMBOBOXTEXT && filterConfig.contextForCombobox && (
                          <>
                            <label className="ms-Label label-filter mt-2">{filterConfig.placeholder}</label>
                            <ComboBoxSearch
                              options={filterConfig.contextForCombobox ? filterConfig.contextForCombobox : []}
                              selected={[getOptionByValuess(props.filters[filterConfig.name], filterConfig.contextForCombobox)]}
                              onSelectOption={(opt) => {
                                _onChangeSelectFiltersss(opt, filterConfig.name);
                              }}
                              cleanOnSelect={false}
                              className="combo-box-filter-detaillist"
                            ></ComboBoxSearch>
                          </>
                        )}

                        {!filterConfig.hidden && filterConfig.type === TYPES.COMBOBOX_USER && filterConfig.contextForCombobox && (
                          <>
                            <label className="ms-Label label-filter mt-2">{filterConfig.placeholder}</label>
                            <ComboBoxSearch
                              options={filterConfig.contextForCombobox ? filterConfig.contextForCombobox : []}
                              selected={[getOptionByValue(props.filters[filterConfig.name], filterConfig.contextForCombobox)]}
                              onSelectOption={(opt) => {
                                _onChangeSelectFilter(opt, filterConfig.name);
                              }}
                              cleanOnSelect={false}
                              className="combo-box-filter-detaillist"
                            ></ComboBoxSearch>
                          </>
                        )}

                        {!filterConfig.hidden && filterConfig.type === TYPES.COMBOBOX && filterConfig.contextForCombobox && (
                          <>
                            <label className="ms-Label label-filter mt-2">{filterConfig.placeholder}</label>
                            <ComboBoxSearch
                              options={filterConfig.contextForCombobox ? filterConfig.contextForCombobox : []}
                              selected={[getOptionByValue(props.filters[filterConfig.name], filterConfig.contextForCombobox)]}
                              onSelectOption={(opt) => {
                                _onChangeSelectFilter(opt, filterConfig.name);
                              }}
                              cleanOnSelect={false}
                              className="combo-box-filter-detaillist"
                            ></ComboBoxSearch>
                          </>
                        )}

                        {!filterConfig.hidden && filterConfig.type === TYPES.COMBOBOX_PROJECT && filterConfig.contextForOrganizationChartDropdown && (
                          <OrganizationChartDropdown
                            className="filter-textfield-list-util-project"
                            label={filterConfig.placeholder}
                            options={filterConfig.contextForOrganizationChartDropdown ? filterConfig.contextForOrganizationChartDropdown : []}
                            selectedKey={getOptionByValueForOrganization(props.filters[filterConfig.name], filterConfig.contextForOrganizationChartDropdown)}
                            onChange={(node: OrganizationChartNode) => {
                              _onChangeSelectFilterForOrganization(node.getId(), filterConfig.name);
                            }}
                          />
                        )}

                        {!filterConfig.hidden && filterConfig.type === TYPE_BUTTON ? <DefaultButton toggle primary={!!props.filters[filterConfig.name]} checked={!!props.filters[filterConfig.name]} text={filterConfig.labelForCheckbox} name={filterConfig.name} className="btn-filter-wrapper" onClick={(e) => onChangeToggleButton(e, filterConfig.name)} disabled={filterConfig.disabled} /> : null}

                        {!filterConfig.hidden && (filterConfig.type === TYPE_DATE || filterConfig.type === TYPE_DATE_YEAR_MONTH) && filterConfig.name !== 'liq_fecha_carga' && filterConfig.name !== 'liq_desde' ? (
                          <>
                            <DatePicker strings={getLocalizedStrings()} label={filterConfig.placeholder} onSelectDate={(e) => handleDateChangeWrapper(e, filterConfig.name, !!filterConfig.isMonthSelector)} formatDate={filterConfig.formatDate ? filterConfig.formatDate : DateCustom.formatDateForDatePicker} value={props.filters[filterConfig.name] ? new Date(props.filters[filterConfig.name]) : undefined} styles={CalendarStyles} className="filter-textfield-list" disabled={filterConfig.disabled} calendarProps={filterConfig.calendarProps} />
                          </>
                        ) : null}

                        {!filterConfig.hidden && (filterConfig.type === TYPE_DATE || filterConfig.type === TYPE_DATE_YEAR_MONTH) && filterConfig.name === 'liq_fecha_carga' ? ( 
                          <>
                            <DatePicker strings={getLocalizedStrings()} label={filterConfig.placeholder} onSelectDate={(e) => handleDateChangeWrapper(e, filterConfig.name, !!filterConfig.isMonthSelector)} formatDate={filterConfig.formatDate ? filterConfig.formatDate : DateCustom.formatDateForDatePicker} value={props.filters[filterConfig.name] ? new Date(props.filters[filterConfig.name]) : undefined} styles={CalendarStyles} className="filter-textfield-list" disabled={filterConfig.disabled} calendarProps={filterConfig.calendarProps} />
                          </>
                        ) : null}

                        {!filterConfig.hidden && (filterConfig.type === TYPE_DATE || filterConfig.type === TYPE_DATE_YEAR_MONTH) && filterConfig.name === 'liq_desde' ? ( 
                          <>
                            <span
                              style={{
                                color: '#aaa',
                                fontSize: '12px',
                                fontWeight: '500',
                              }}
                            >
                              {filterConfig.placeholder}
                            </span>
                            <CustomDatePicker
                              strings={getLocalizedStrings()}
                              label={''}
                              value={props.filters[filterConfig.name] ? new Date(new Date(props.filters[filterConfig.name]).setDate(new Date(props.filters[filterConfig.name]).getDate() + 1)) : undefined}
                              minDate={(function getMinDateFromConfig() {
                                const config = localStorage.getItem('/system/config');
                                if (config) {
                                  const parsedConfig = JSON.parse(config);
                                  if (parsedConfig.data.conf_fecha_bloqueo_actividades) {
                                    const [day, month, year] = parsedConfig.data.conf_fecha_bloqueo_actividades.split('/');
                                    return new Date(Number(year), Number(month) - 1, Number(day));
                                  }
                                }
                                return new Date(); // Valor predeterminado en caso de que no exista el valor
                              })()}
                              blockedMonths={{}}
                              onSelectDate={(e) => handleDateChangeWrapperMonth(e, filterConfig.name, !!filterConfig.isMonthSelector)}
                            />
                          </>
                        ) : null}

                        {/*   */}
                        {!filterConfig.hidden && filterConfig.type === TYPE_DATE_HASTA ? (
                          <>
                            <DatePicker strings={getLocalizedStrings()} label={filterConfig.placeholder} placeholder={t("selecione una fecha en desde")} onSelectDate={(e) => handleDateChangeWrapper(e, filterConfig.name, !!filterConfig.isMonthSelector)} formatDate={filterConfig.formatDate ? filterConfig.formatDate : DateCustom.formatDateForDatePicker} value={props.filters[filterConfig.name] ? new Date(props.filters[filterConfig.name]) : undefined} styles={CalendarStyles} className="filter-textfield-list" disabled={props.filters['desde'] ? false : true} calendarProps={filterConfig.calendarProps} />
                          </>
                        ) : null}

                        {!filterConfig.hidden && filterConfig.type === TYPE_DATE_PROJECT ? (
                          <>
                            <DatePicker strings={getLocalizedStrings()} label={filterConfig.placeholder} onSelectDate={(e) => handleDateChangeWrapper(e, filterConfig.name, !!filterConfig.isMonthSelector)} formatDate={filterConfig.formatDate ? filterConfig.formatDate : DateCustom.formatDateForDatePicker} value={props.filters[filterConfig.name] ? new Date(props.filters[filterConfig.name]) : undefined} styles={CalendarStyles} className="filter-textfield-list-date-picker" disabled={filterConfig.disabled} calendarProps={filterConfig.calendarProps} />
                          </>
                        ) : null}

                        {!filterConfig.hidden && filterConfig.type === TYPE_DATETIME ? (
                          <div className="">
                            <DatePicker strings={getLocalizedStrings()} label={filterConfig.placeholder} onChange={(e: any) => handleDateChangeWrapper(e, filterConfig.name, !!filterConfig.isMonthSelector)} className="filter-textfield-list" styles={CalendarStyles} disabled={filterConfig.disabled} />
                            <i className=" into-input fa fa-calendar"></i>
                          </div>
                        ) : null}

                        {/* {filterConfig.customFilter ? <div>{filterConfig.customFilter}</div> : null} */}
                    </div>
                  );
                })
            : null}
        </div>
      </div>
    </div>
  );
};

export default FilterWrapperForList;
